module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start"
  }, [_vm._m(0), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "readme",
    domProps: {
      "innerHTML": _vm._s(_vm.doc)
    }
  })]), _c('div', {
    staticClass: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/vblLayout"
    }
  }, [_c('vbl-button', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("马上开始")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("<vbl/>")]), _c('p', [_vm._v("vue backend library")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea06d96e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./docs-src/start.vue
// module id = 296
// module chunks = 0